import { render, staticRenderFns } from "./CategoryMapping.vue?vue&type=template&id=74a93272&"
import script from "./CategoryMapping.vue?vue&type=script&lang=js&"
export * from "./CategoryMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports